import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function AllSetPage() {
    const navigate = useNavigate()

    const handleSetAll = () => {
        localStorage.setItem("setAll", "yes")
        navigate("/artwork_list", { state: { modal: true } })
    }

    return (
        <div className="min-h-[calc(100vh-150px)] flex items-center justify-center max-w-screen-xl mx-auto">
            <div className="bg-[#FFFFFF] w-full rounded-lg shadow flex flex-col items-center justify-center p-8 h-[60vh]">
                <div className="text-center">
                    <h1 className="md:text-3xl text-2xl font-bold text-gray-800 mb-3">
                        You're All Set!
                    </h1>

                    <p className="text-gray-600 mb-10 md:text-base text-sm">
                        Now you can start adding your artwork.
                    </p>

                    <button onClick={handleSetAll} className="md:w-[500px] w-full bg-black text-white py-4 px-8 rounded-lg md:text-base text-sm">
                        Upload Your First Artwork
                    </button>
                </div>
            </div>
        </div>
    )
}
